import React from "react";
import { TableHead, TableRow } from "@material-ui/core";
import SortableCell from "../../../commons/grid/SortableCell.jsx";
import { buildMovilesInmovilizadosColumns } from "./movilesInmovilizadosColumns.js";

/**
 * El thead recorre la MISMA lista de columnas que la fila (`movilesInmovilizadosColumns.js`).
 *
 * Antes las seis celdas estaban escritas a mano acá y las seis en la fila, sin nada que las
 * atara: agregar una en un solo lado desfasaba la tabla entera, y no da error de compilación
 * ni de runtime — los datos aparecen bajo el título equivocado y hay que notarlo mirando.
 *
 * `SortableCell` es el mismo componente que usan Móviles y Tickets: sin `onSort` una columna no
 * sería ordenable (ni cursor, ni icono), así que las seis lo son porque el backend las soporta.
 *
 * @param esVisible (name) => bool, del hook `useColumnVisibility` de la grilla.
 * @param sort      `{campo, direccion}` del estado de la grilla.
 * @param onSort    (campo) => void.
 */
const MovilesInmovilizadosTableHeader = ({ esVisible, sort, onSort }) => (
    <TableHead>
        <TableRow>
            {buildMovilesInmovilizadosColumns().map((columna) => (
                <SortableCell
                    key={columna.name}
                    show={esVisible(columna.name)}
                    field={columna.name}
                    sort={sort}
                    onSort={onSort}
                    messageId={columna.messageId}
                    label={columna.label}
                />
            ))}
        </TableRow>
    </TableHead>
);

export default MovilesInmovilizadosTableHeader;
